import React from 'react';
import { Pencil } from 'lucide-react';

interface EditButtonProps {
  onClick: () => void;
}

const EditButton: React.FC<EditButtonProps> = ({ onClick }) => {
  return (
    <div className="relative group">
      <button
        className="text-blue-600 hover:text-blue-800"
        onClick={onClick}
        title="Edit"
      >
        <Pencil className="w-4 h-4" />
      </button>
      <span className="absolute -top-7 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Edit
      </span>
    </div>
  );
};

export default EditButton;
